import * as React from 'react';

const CheckInCircle = ({ iconColor = 'rgba(14, 19, 35, 0.35)' }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15C8 11.1546 11.1546 8 15 8C18.8454 8 22 11.1546 22 15C22 18.8454 18.8454 22 15 22C11.1546 22 8 18.8454 8 15ZM15 6C10.05 6 6 10.05 6 15C6 19.95 10.05 24 15 24C19.95 24 24 19.95 24 15C24 10.05 19.95 6 15 6ZM14 16.1L18.3 11.8C18.7 11.4 19.3 11.4 19.7 11.8C20.1 12.2 20.1 12.8 19.7 13.2L14.7 18.2C14.5 18.4 14.2 18.5 14 18.5C13.8 18.5 13.5 18.4 13.3 18.2L10.3 15.2C9.9 14.8 9.9 14.2 10.3 13.8C10.7 13.4 11.3 13.4 11.7 13.8L14 16.1Z"
      fill={iconColor}
    />
  </svg>
);
export default CheckInCircle;
